import { useState } from "react"
//init state
import { auth } from "../firebase/config"
import { signInWithEmailAndPassword } from "firebase/auth"
import { useAuthContext } from "./useAuthContext"
import { Notification } from "../components/Notification"
import useAdminModeStore from "../store/Admin/adminMode"

export const useLogin = () => {
  const [error, setError] = useState(null)
  const { dispatch } = useAuthContext()
  const { setAdminMode } = useAdminModeStore()

  const login = (email, password) => {
    setError(null)
    signInWithEmailAndPassword(auth, email, password)
      .then((res) => {
        auth.currentUser
          .getIdTokenResult()
          .then((idTokenResult) => {
            // switch()
            // Confirm the user is an Admin.
            //ADMIN
            if (!!idTokenResult.claims.admin) {
              dispatch({
                type: "LOGIN",
                payload: res.user,
                isadmin: true,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("admin")
              //PAPER MANAGER
            } else if (!!idTokenResult.claims.paperManager) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: true,
                designer: false,
                blankManager: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("paper manager")
              //PAPER DESIGNER
            } else if (!!idTokenResult.claims.designer) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: true,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("designer")
              //BLANK MANAGER
            } else if (!!idTokenResult.claims.semiAdmin) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: true,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("semiAdmin")
              //PAPER BASIC MANAGER
            } else if (!!idTokenResult.claims.accountant) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: true,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
            } else if (!!idTokenResult.claims.arsomaUser) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: true,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("arsoma user")
              //PAPER BASIC MANAGER
            } else if (!!idTokenResult.claims.vivaUser) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: true,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("viva user")
            } else if (!!idTokenResult.claims.warehouse) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: true,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("warehouse")
            } else if (!!idTokenResult.claims.winder) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: true,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("winder")
            } else if (!!idTokenResult.claims.tapeUser) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: true,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("tapeUser")
              //CUTTER
            } else if (!!idTokenResult.claims.cutter) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: true,
                sales: false,
                devSpecialist: false,
              })
              console.log("cutter")
              //SALES
            } else if (!!idTokenResult.claims.cutter) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: true,
                devSpecialist: false,
              })
              console.log("cutter")
              //BASIC USER
            } else if (!!idTokenResult.claims.devSpecialist) {
              dispatch({
                type: "AUTH_IS_READY",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: true,
                devSpecialist: false,
              })
              console.log("dev specialist")
              // DEV SPECIALIST
            } else {
              dispatch({
                type: "LOGIN",
                payload: res.user,
                isadmin: false,
                ispaperManager: false,
                designer: false,
                semiAdmin: false,
                isAccountant: false,
                arsomaUser: false,
                vivaUser: false,
                warehouse: false,
                winder: false,
                tapeUser: false,
                cutter: false,
                sales: false,
                devSpecialist: false,
              })
              console.log("basic user")
            }
          })
          .catch((error) => {
            console.log(error)
          })

        console.log(res.user)
      })
      .then(() => {
        Notification("success", "Login Accepted", "You have successfully logged in!")
        setAdminMode(false)
      })
      .catch((err) => {
        setError(err.message)
        Notification("error", "Login Error", error)
      })
  }

  return { error, login }
}
